<div class="white-shadow-container">
    <mat-tab-group>
      <mat-tab label="Про громадську організацію">
        <div [innerHTML]="getTrustedHtml(generalInfo?.aboutUs)" class="contacts-container">    
        </div>
      </mat-tab>
      <mat-tab label="Контакти">
        <div [innerHTML]="getTrustedHtml(generalInfo?.contacts)" class="contacts-container">    
        </div>
      </mat-tab>
    </mat-tab-group>
</div>
  